module.exports = "/images/select-arrow.svg?2d200c03fb1bac66c43fc2e7f1609790";